<div *ngFor="let item of arrNumber">
    <nz-skeleton *ngIf="isProcess" [nzActive]="true"></nz-skeleton>
</div>